var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.5C2 12.5 6.71831 6 12 6C17.7183 6 22 12.5 22 12.5C22 12.5 17.7183 19 12 19C6.71831 19 2 12.5 2 12.5ZM4.38095 12.4993C5.36956 13.6864 8.30546 17 12 17C15.7028 17 18.6315 13.6867 19.619 12.5C18.6302 11.3127 15.6945 8 12 8C8.29715 8 5.36849 11.3123 4.38095 12.4993Z",
    fill: "#B9BDC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5C15 14.1569 13.6569 15.5 12 15.5C10.3431 15.5 9 14.1569 9 12.5C9 10.8431 10.3431 9.5 12 9.5C13.6569 9.5 15 10.8431 15 12.5Z",
    stroke: "#B9BDC6",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOnIcon);
export default __webpack_public_path__ + "static/media/eyeOnIcon.54a512ff782692d462d836ef0c3b7f6e.svg";
export { ForwardRef as ReactComponent };